import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { paymentMethodInitialsForAdd, paymentMethodInitialsForUpdate } from './interfaces/paymentMethodClass';
import { addPaymentMethodsAsync, updatePaymentMethodsAsync, resetSelectedRecordObjectInState } from './paymentMethodSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { getValueFromResource } from '../../../common/timeLiveFunction';

const PaymentMethodForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
    const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(paymentMethodInitialsForAdd);
    const { selectedRecord, paymentMethodList, isLoading } = useAppSelector((state) => state.paymentMethod);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(paymentMethodInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(paymentMethodInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        calculatedDisabledValue();

    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updatePaymentMethodsAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Payment Method Update Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addPaymentMethodsAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Payment Method Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }

    const calculatedDisabledValue = () => {
        if (paymentMethodList.length > 0) {
            let index = 0;
            paymentMethodList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(paymentMethodList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    PaymentMethod: yup
                        .string()
                        .label('PaymentMethod')
                        .trim()
                        .required
                        // (t('Payment method is required')),
                        (getValueFromResource('Payment method is required',dispatch, t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                                         //  t('Update')
                                                           getValueFromResource('Update ',dispatch, t) : 
                                                        //   t('Add')} 
                                                        getValueFromResource('Add ',dispatch, t)}

                                                          {/* {t('Payment Method')}  */}
                                                          {getValueFromResource('Payment Method',dispatch, t)}

                                                          </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-0">
                                                                <label className="fs-7 fw-normal">
                                                                    {/* {t('Payment Method')} */}
                                                                    {getValueFromResource('Payment Method',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mt-2" id='PaymentMethod' value={values.PaymentMethod} name='PaymentMethod'
                                                                    onChange={handleChange('PaymentMethod')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('PaymentMethod', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom: 5 }}>
                                                                {touched.PaymentMethod && errors.PaymentMethod &&
                                                                    <p className='errorMsg'>{errors.PaymentMethod as string}</p>
                                                                }
                                                            </div>

                                                            {/* {Object.keys(selectedRecord).length > 0 ? (
                                                                <div className="mb-3 mt-2" >
                                                                    <label className="fs-7 fw-normal">{t('Disabled')}</label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : null} */}
                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                disabledCount !== 1 ? <div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}
                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div> : paymentMethodList.find(x => x.AccountPaymentMethodId === values.AccountPaymentMethodId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}
                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div>)
                                                            ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                            {/* {t('Save')} */}
                                                            {getValueFromResource('Save',dispatch, t)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )


}

export default PaymentMethodForm